var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArticlePink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 132,
    viewBox: "0 0 135 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 43,
    width: 45,
    height: 45,
    rx: 22.5,
    fill: "#F8F2F7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_29890_73259)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.6875 56.7375H62.25C61.5117 56.7375 60.9375 57.3528 60.9375 58.05V71.8313C60.9375 72.2004 60.6094 72.4875 60.2812 72.4875C59.9121 72.4875 59.625 72.2004 59.625 71.8313V59.3625H58.3125C57.5742 59.3625 57 59.9778 57 60.675V72.4875C57 73.9641 58.1484 75.1125 59.625 75.1125H75.375C76.8105 75.1125 78 73.9641 78 72.4875V58.05C78 57.3528 77.3848 56.7375 76.6875 56.7375ZM68.1562 72.4875H64.2188C63.8496 72.4875 63.5625 72.2004 63.5625 71.8313C63.5625 71.5032 63.8496 71.175 64.2188 71.175H68.1562C68.4844 71.175 68.8125 71.5032 68.8125 71.8313C68.8125 72.2004 68.4844 72.4875 68.1562 72.4875ZM68.1562 68.55H64.2188C63.8496 68.55 63.5625 68.2629 63.5625 67.8938C63.5625 67.5657 63.8496 67.2375 64.2188 67.2375H68.1562C68.4844 67.2375 68.8125 67.5657 68.8125 67.8938C68.8125 68.2629 68.4844 68.55 68.1562 68.55ZM74.7188 72.4875H70.7812C70.4121 72.4875 70.125 72.2004 70.125 71.8313C70.125 71.5032 70.4121 71.175 70.7812 71.175H74.7188C75.0469 71.175 75.375 71.5032 75.375 71.8313C75.375 72.2004 75.0469 72.4875 74.7188 72.4875ZM74.7188 68.55H70.7812C70.4121 68.55 70.125 68.2629 70.125 67.8938C70.125 67.5657 70.4121 67.2375 70.7812 67.2375H74.7188C75.0469 67.2375 75.375 67.5657 75.375 67.8938C75.375 68.2629 75.0469 68.55 74.7188 68.55ZM75.375 63.9563C75.375 64.3254 75.0469 64.6125 74.7188 64.6125H64.2188C63.8496 64.6125 63.5625 64.3254 63.5625 63.9563V60.0188C63.5625 59.6907 63.8496 59.3625 64.2188 59.3625H74.7188C75.0469 59.3625 75.375 59.6907 75.375 60.0188V63.9563Z",
    fill: "#A0438B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_29890_73259",
    x: 0.75,
    y: 0.487549,
    width: 133.5,
    height: 130.875,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 28.125
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.329412 0 0 0 0 0.529412 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_29890_73259"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_29890_73259",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArticlePink);
export default __webpack_public_path__ + "static/media/article-pink.b6195924.svg";
export { ForwardRef as ReactComponent };